import React, { useState } from "react";
import { Star } from "lucide-react";

const Rating = ({ maxStars = 5, onRate, rated, className }) => {
    const [hovered, setHovered] = useState(0);

    const handleClick = (rating) => {
        if (onRate) onRate(rating);
    };

    return (
        <div className="flex space-x-1">
            {[...Array(maxStars)].map((_, index) => {
                const rating = index + 1;
                return (
                    <Star
                        key={rating}
                        size={25}
                        className={`star ${rating <= (hovered || rated) ? "active" : "inactive"} ${className}`}
                        onMouseEnter={() => setHovered(rating)}
                        onMouseLeave={() => setHovered(0)}
                        onClick={() => handleClick(rating)}
                    />
                );
            })}
        </div>
    );
};

export default Rating;
